export const CREATE_DEFINITION = 'CREATE_DEFINITION'
export const CREATE_DEFINITION_SUCCESS = 'CREATE_DEFINITION_SUCCESS'
export const FETCH_DEFINITIONS = 'FETCH_DEFINITIONS'
export const FETCH_DEFINITIONS_SUCCESS = 'FETCH_DEFINITIONS_SUCCESS'
export const REMOVE_DEFINITION = 'REMOVE_DEFINITION'
export const REMOVE_DEFINITION_SUCCESS = 'REMOVE_DEFINITION_SUCCESS'
export const UNDO_DEFINITION_CHANGE = 'UNDO_DEFINITION_CHANGE'
export const UPDATE_DEFINITION = 'UPDATE_DEFINITION'
export const UPDATE_DEFINITION_SUCCESS = 'UPDATE_DEFINITION_SUCCESS'
export const UPDATE_DEFINITIONS_TO_PUBLISH = 'UPDATE_DEFINITIONS_TO_PUBLISH'
export const PUBLISH_DICTIONARY = 'PUBLISH_DICTIONARY'
